const STATUS_CONFIG: Record<string, { bg: string; color: string; label: string }> = {
  queued:    { bg: '#e3f2fd', color: '#1565c0', label: 'Queued' },
  running:   { bg: '#e8f5e9', color: '#1b5e20', label: 'Running' },
  succeeded: { bg: '#f1f8e9', color: '#33691e', label: 'Succeeded' },
  failed:    { bg: '#ffebee', color: '#b71c1c', label: 'Failed' },
  cancelled: { bg: '#f5f5f5', color: '#616161', label: 'Cancelled' },
  timed_out: { bg: '#fff3e0', color: '#e65100', label: 'Timed out' },
}

interface Props {
  status: string
}

export default function JobStatusBadge({ status }: Props) {
  const cfg = STATUS_CONFIG[status] ?? { bg: '#f5f5f5', color: '#555', label: status }
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 700,
        background: cfg.bg,
        color: cfg.color,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
    </span>
  )
}
